/**
 * Filter scroll-adjust
 *
 * Watches a filterable section for card-visibility changes (Alpine toggles
 * `display: none` via x-show). When a filter shrinks the result set so far
 * that the user is left staring at the footer, smooth-scrolls the filter
 * bar back into view at its sticky anchor. No-op when visible cards still
 * fill the viewport, so routine pill tweaks don't jump.
 */
export default function setupFilterScrollAdjust () {
  const filterBar = document.querySelector('.filter-bar--light')
  if (!filterBar) return

  const section = filterBar.closest('section, .section') || document.body

  let rafId = null

  function adjust () {
    cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(() => {
      const filterRect = filterBar.getBoundingClientRect()
      const stickyTop = parseFloat(getComputedStyle(filterBar).top) || 0

      // Find the last currently-visible card inside the section
      const cards = section.querySelectorAll('.card-d, .filter-card')
      let lastBottom = -Infinity
      for (const card of cards) {
        if (card.offsetParent === null) continue
        const b = card.getBoundingClientRect().bottom
        if (b > lastBottom) lastBottom = b
      }
      if (lastBottom === -Infinity) return

      // If the last visible card sits above where the filter bar would stick,
      // the user is looking at the footer — pull the filter back into view.
      const anchor = stickyTop + filterRect.height + 20
      if (lastBottom > anchor) return

      const filterAbsTop = filterRect.top + window.scrollY
      const target = Math.max(0, filterAbsTop - stickyTop)
      if (Math.abs(target - window.scrollY) < 4) return

      window.scrollTo({ top: target, behavior: 'smooth' })
    })
  }

  const observer = new MutationObserver(adjust)
  observer.observe(section, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style', 'class', 'hidden'],
  })
}
